import React, {useState, useEffect, useRef, useMemo, useCallback} from 'react';
import { View, TouchableOpacity } from 'react-native'

import tw from '../../../../styles/tailwind';
import Text from '../../../../components/Text';
import Icon from '../../../../components/IcomoonIcon';
import Input from '../../../../components/Forms/Input';
import { useForm } from 'react-hook-form';
import IconButton from '../../../../components/IconButton';


import BottomSheet from '../../../../components/BottomSheet';
import useFormSubmit from '../../../../hooks/useFormSubmit';
import FilePicker from '../../../../components/FilePicker';


export default function NewAnnouncementModal({ onRequestClose, onAnnouncementCreated, visible, communityId }) {
  const { control, handleSubmit, setValue } = useForm();


  const { submitForm, isSubmitting } = useFormSubmit({
    onSuccess: onAnnouncementCreated,
    onError: (error) => { },
    successToastMessage: "Comunicado creado",
    endpoint: `/communities/${communityId}/announcements`,
  })


  return (
    <BottomSheet
      height={700}
      visible={visible}
      onRequestClose={onRequestClose}
      showCloseButton={true}
    >
      <View style={tw`px-5`}>
        <View style={tw`row justify-between mb-4 mt-5`}>
          <Text style={tw`text-lg font-600 text-secondary`}>Nuevo Aviso</Text>

          <TouchableOpacity
            style={tw`items-center justify-center mr-2`}
            onPress={onRequestClose}
          >
            <Icon name='close' style={tw`text-red`} size={26} />
          </TouchableOpacity>
        </View>

        <View style={tw`mb-0`}>
          <Text style={tw`text-gray-500`}>Título</Text>
          <Input
            control={control}
            name='title'
            style={{ subcontainer: tw`rounded-lg` }}
            maxLength={100}
            rules={{required: true}}
          />
        </View>

        <View style={tw`mb-0`}>
          <Text style={tw`text-gray-500`}>Descripción</Text>
          <Input
            control={control}
            name='text'
            multiline
            numberOfLines={5}
            style={{ subcontainer: tw`rounded-lg`, input: {height: 120, textAlignVertical: 'top'} }}
            rules={{required: true}}
          />
        </View>

        <View style={tw`mb-6`}>
          <FilePicker
            onFileSelected={file => {
              // console.log("onfileselected", file)
              setValue('file_uid', file?.uuid)
            }}
            label="Seleccionar imagen"
            postUrl={`/communities/${communityId}/images`}
          />
        </View>

        <IconButton
          title={"Crear Aviso"}
          disabled={isSubmitting}
          style={tw`self-end`}
          onPress={handleSubmit(submitForm)}
        />
      </View>

    </BottomSheet>
  );
}

{/* <BottomSheet onRequestClose={onRequestClose} visible={visible} height={250}>
  <View style={tw`pt-5 px-5`}>
    <Text style={tw`mb-4 text-lg font-600 text-secondary`}>Comentar</Text>

    <View style={tw`mb-0`}>
      <Input control={control} name='name' multiline numberOfLines={5} style={{ subcontainer: tw`rounded-lg` }} />
    </View>

    <IconButton title={"Guardar"} style={tw`self-end`} />
  </View>
</BottomSheet> */}